import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

// A minimal operator shell. It reuses the app's design tokens but NOT
// SettingsLayout: that shell is tenant-app furniture (Exit-to-app, the
// detected-sources badge, the categorized sidebar) and an operator has no
// tenant to exit to.
export default function PlatformLayout() {
	const { keycloak } = useKeycloak();
	const email = keycloak?.tokenParsed?.email || "operator";

	return (
		<div className="min-h-screen bg-surface text-text">
			<header className="flex items-center justify-between border-b border-card-bd bg-card px-6 py-3">
				<div className="flex items-center gap-6">
					<span className="text-sm font-semibold tracking-wide">InstantView Platform</span>
					<NavLink
						to="/tenants"
						className={({ isActive }) =>
							`text-[13px] ${isActive ? "text-primary" : "text-text-2 hover:text-text"}`
						}
					>
						Tenants
					</NavLink>
				</div>
				<div className="flex items-center gap-4 text-[13px] text-text-2">
					<span>{email}</span>
					<button
						type="button"
						onClick={() => keycloak?.logout()}
						className="box-border rounded-ctrl border border-solid border-card-bd px-3 py-1 text-text-2 hover:text-text"
					>
						Sign out
					</button>
				</div>
			</header>
			<main className="mx-auto max-w-[1200px] px-6 py-6">
				<Outlet />
			</main>
		</div>
	);
}
